import { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { useCurrentBillingPeriod, useGetBillingPeriods, useRefreshConsumerBillingService } from '@app/sdk';
import EffectiveDateSelector from '../components/EffectiveDateSelector';

export default function CreatePayment(props) {
  const { accountId, transactionService, setError, billingDate } = useContext(AccountContext);
  const [amount, setAmount] = useState(0.0);
  const [description, setDescription] = useState('A Payment');
  const [creatingPayment, setCreatingPayment] = useState(false as boolean);
  const [effectiveDate, setEffectiveDate] = useState(billingDate as Date);
  const [creditRelease, setCreditRelease] = useState('Immediate');
  const refreshConsumerBillingService = useRefreshConsumerBillingService(accountId);
  const { data: billingPeriods } = useGetBillingPeriods(accountId);
  const { data: currentBillingPeriod } = useCurrentBillingPeriod(accountId);
  const { paymentCreated } = props;

  useEffect(() => {
    setEffectiveDate(billingDate);
  }, [billingDate]);

  const onPaymentClicked = async () => {
    try {
      setCreatingPayment(true);
      await transactionService.payment(accountId, amount, description, effectiveDate, creditRelease);
      paymentCreated(new Date());
      setCreatingPayment(false);

      setTimeout(async () => {
        await refreshConsumerBillingService();
      }, 5000);
    } catch (error) {
      setCreatingPayment(false);
      setError({ source: 'Create Payment', ...error });
    }
  };

  return (
    <div className="ui card">
      <div className="custom-card-header">Make a Payment</div>
      <div className="content">
        <div className="ui form">
          <div className="field">
            <label>Amount</label>
            <div className="ui labeled input">
              <div className="ui label">£</div>
              <input
                type="number"
                placeholder="Amount"
                step=".01"
                disabled={creatingPayment}
                onChange={(e) => setAmount(parseFloat(e.target.value))}
              />
            </div>
          </div>
          <div className="field">
            <label>Description</label>
            <input
              type="text"
              placeholder="Description"
              value={description}
              disabled={creatingPayment}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <EffectiveDateSelector
            baseDate={billingDate}
            effectiveDate={effectiveDate}
            onChange={setEffectiveDate}
            billingPeriods={billingPeriods}
            currentBillingPeriod={currentBillingPeriod}
            disabled={creatingPayment}
          />
          <div className="field">
            <div className="ui labeled input">
              <div className="ui label">Credit release</div>
              <select onChange={(e) => setCreditRelease(e.target.value)}>
                <option value="Immediate">Immediate</option>
                <option value="Delayed">Delayed</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <button
        className={`ui primary button ${creatingPayment && 'loading'}`}
        type="submit"
        onClick={() => onPaymentClicked()}>
        Make Payment
      </button>
    </div>
  );
}
